// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QYoh5e {
  position: relative;
  width: 100%;
}

.TR4gHA {
  display: flex;
  align-items: center;
  width: 100%;
  height: 74px;
  background: var(--surface-neutral-pale, #fafafa);
  border: none;
  border-radius: var(--radius-s);
  padding: var(--spacing-2, 16px);
  cursor: pointer;
  opacity: 1;
}

.pceeQU {
  display: flex;
  align-items: center;
  justify-content: center;
}

.EwWz2c {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: var(--background-white, #ffffff);
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ggZqUI {
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.V6uAR6 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark, #1f1f1f);
}

.e5vbbk {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark, #1f1f1f);
}

.p35eUD {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark, #1f1f1f);
}

.QV7EWh {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: var(--spacing-2);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
}

.IqwtmJ {
  cursor: pointer;
  object-fit: cover;
}

/* Dropdown styles based on Figma design */
.xoZ55j {
  position: absolute;
  top: 65%;
  right: 10px;
  width: 220px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  padding: 8px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.Td1Rdo {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: background-color 0.15s ease;
}

.Td1Rdo:hover {
  background: #f2f2f2;
  .nD4uHC {
    color: var(--status-error, #dc0a0a);
  }
}

.Td1Rdo:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.Td1Rdo:disabled:hover {
  background: transparent;
  .nD4uHC {
    color: var(--text-neutral-dark, #1f1f1f);
  }
}

.NG6HqT {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: #00539b;
}

.zavTLy {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  color: var(--status-error, #dc0a0a);
}

.G7YtOX {
  width: 12px;
  height: 12px;
  object-fit: contain;
}

.nD4uHC {
  font-family: 'Source Sans 3', var(--font-family-base);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #1f1f1f;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AccountsPayableTransaction/AccountsPayableTransaction.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".transactionContainer {\n  position: relative;\n  width: 100%;\n}\n\n.transaction {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 74px;\n  background: var(--surface-neutral-pale, #fafafa);\n  border: none;\n  border-radius: var(--radius-s);\n  padding: var(--spacing-2, 16px);\n  cursor: pointer;\n  opacity: 1;\n}\n\n.image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.imageContainer {\n  width: 32px;\n  height: 32px;\n  border-radius: 16px;\n  background: var(--background-white, #ffffff);\n  margin-right: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.info {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.amount {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.threeDotsButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: var(--spacing-2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n}\n\n.imageThreeDotsVerticalOrange {\n  cursor: pointer;\n  object-fit: cover;\n}\n\n/* Dropdown styles based on Figma design */\n.dropdown {\n  position: absolute;\n  top: 65%;\n  right: 10px;\n  width: 220px;\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.dropdownItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  transition: background-color 0.15s ease;\n}\n\n.dropdownItem:hover {\n  background: #f2f2f2;\n  .dropdownText {\n    color: var(--status-error, #dc0a0a);\n  }\n}\n\n.dropdownItem:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.dropdownItem:disabled:hover {\n  background: transparent;\n  .dropdownText {\n    color: var(--text-neutral-dark, #1f1f1f);\n  }\n}\n\n.statusNeutral {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: #00539b;\n}\n\n.statusReviewRequired {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  color: var(--status-error, #dc0a0a);\n}\n\n.dropdownIcon {\n  width: 12px;\n  height: 12px;\n  object-fit: contain;\n}\n\n.dropdownText {\n  font-family: 'Source Sans 3', var(--font-family-base);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8;\n  color: #1f1f1f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transactionContainer": `QYoh5e`,
	"transaction": `TR4gHA`,
	"image": `pceeQU`,
	"imageContainer": `EwWz2c`,
	"info": `ggZqUI`,
	"title": `V6uAR6`,
	"description": `e5vbbk`,
	"amount": `p35eUD`,
	"threeDotsButton": `QV7EWh`,
	"imageThreeDotsVerticalOrange": `IqwtmJ`,
	"dropdown": `xoZ55j`,
	"dropdownItem": `Td1Rdo`,
	"dropdownText": `nD4uHC`,
	"statusNeutral": `NG6HqT`,
	"statusReviewRequired": `zavTLy`,
	"dropdownIcon": `G7YtOX`
};
module.exports = ___CSS_LOADER_EXPORT___;
